import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { mdiClose } from '@mdi/js';
import { Icon } from '@mdi/react';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useCallback, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';
import DefaultBackdrop from '../DefaultBackdrop';
import { ModificationsForm } from '../../components/ModificationsForm';
import { defineStyles } from '../../theme';
import { useShowInfoDialog } from '../../infoDialogs';
import { sameValuesEntries } from '../BatchEditDialog/helpers';
import { useHandleOk } from '../BatchEditDialog/useHandleOk';
const styles = defineStyles({
    root: {
        height: '100%',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    headerText: {
        display: 'flex',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
});
export function SingleEditDialog({ open, onClose, visibleColumns, selectedRow, allowNewColumns, invalidateTable, singleEditApiCall, }) {
    const [isLoading, setIsLoading] = useState(false);
    const showInfoDialog = useShowInfoDialog();
    const formDefaultValues = useMemo(() => sameValuesEntries([selectedRow]), [selectedRow]);
    const handleClose = useCallback((_, reason) => {
        if (reason === 'backdropClick') {
            return;
        }
        onClose();
    }, [onClose]);
    const onOk = useHandleOk(async (modifications) => {
        setIsLoading(true);
        try {
            const response = await singleEditApiCall(modifications, selectedRow.ipsosId);
            onClose();
            invalidateTable();
            setIsLoading(false);
            if (!response)
                return;
            if (response.rowCount) {
                const blocked = response.rowCount;
                const all = 1;
                const changed = all - blocked;
                showInfoDialog({
                    title: (_jsx(FormattedMessage, { id: "singleEditDialog.warning", values: { blocked, all, changed }, defaultMessage: "warning {blocked}, {all}, {changed}" })),
                });
            }
        }
        catch (error) {
            console.error(error);
            toast(_jsx(FormattedMessage, { ...error }), {
                type: 'error',
            });
        }
        finally {
            setIsLoading(false);
        }
    }, {
        selectedRows: [selectedRow],
        totalRows: 1,
        visibleColumns,
    });
    return (_jsxs(_Fragment, { children: [_jsxs(Dialog, { open: open, maxWidth: "sm", fullWidth: true, onClose: handleClose, sx: styles.root, children: [_jsxs(DialogTitle, { sx: styles.header, children: [_jsx(Box, { sx: styles.headerText, children: _jsx(FormattedMessage, { id: "singleEditDialog.header", defaultMessage: "Single Edit | Editing 1 row" }) }), _jsx(ButtonBase, { onClick: onClose, disableRipple: true, children: _jsx(Icon, { path: mdiClose, size: 1 }) })] }), _jsx(DialogContent, { sx: styles.content, children: _jsx(ModificationsForm, { onSubmit: onOk, onCancel: onClose, visibleColumns: visibleColumns, defaultValues: formDefaultValues, allowNewColumns: allowNewColumns }) })] }), _jsx(DefaultBackdrop, { isLoading: isLoading })] }));
}
//# sourceMappingURL=SingleEditDialog.js.map